import { Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import { IoWarningOutline } from "react-icons/io5";
import { PiSealCheck } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import questionIcon from "../../../assets/images/questionIcon.png";
import {
  InputField,
  Modal,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../components";
import { AssetsMiddleware } from "../../../Store/Middlewares/AssetsMiddleware";
import { PagesMiddleware } from "../../../Store/Middlewares/PagesMiddleware";
import styles from "./lotnumber.module.css";

const LotNumber = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const ref = useRef();
  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState([]);

  const [scheduleSuccessModal, setScheduleSuccessModal] = useState(false);
  const [scheduleDeniedModal, setScheduleDeniedModal] = useState(false);
  const [removeModuleModal, setRemoveModuleModal] = useState(false);
  const [moduleSuccessModal, setModuleSuccessModal] = useState(false);
  const moduleImageref = useRef();

  const [addModule, setAddModule] = useState(false);
  const [lotNumber, setLotNumber] = useState("");
  const [lotAddress, setLotAddress] = useState("");
  const [isedit, setIsEdit] = useState(null);

  const lot_numbers = useSelector((state) => state.PagesReducer.lot_numbers);

  const getData = (name) => {
    dispatch(
      PagesMiddleware.lotnumber({
        params: { name },
        route: "",
        method: "get",
      }),
    );
  };

  useEffect(() => {
    getData(search);
  }, []);

  const onSearch = (e) => {
    setSearch(e.target.value);
    const value = e.target.value;
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      dispatch(
        PagesMiddleware.lotnumber({
          params: { name: value },
          route: "",
          method: "get",
        }),
      );
    }, 1000);
  };

  const onAddLotnumber = () => {
    let userData = {
      name: lotNumber,
      address: lotAddress,
    };
    dispatch(
      PagesMiddleware.lotnumber({
        route: isedit ? `/update` : "/create",
        payload: isedit ? { ...userData, id: isedit } : userData,
        method: "post",
      }),
    ).then(() => {
      setAddModule(false);
      setLotNumber("");
      setLotAddress("");
    });
  };

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      render: (text, data, index) => (
        <div>
          <TextComponent text={index + 1} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Lot Name",
      dataIndex: "name",
      key: "name",
      render: (text) => (
        <div className={styles.module}>
          <TextComponent text={text} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Lot Address",
      dataIndex: "address",
      key: "address",
      render: (text) => (
        <div className={styles.module}>
          <TextComponent text={text} className={styles.versionText} />
        </div>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, data) => (
        <div className={styles.actionCont}>
          <SubmitButton
            title={"Edit"}
            btnClass={styles.actionBtn}
            onClick={() => {
              setAddModule(true);
              setIsEdit(data?.id);
              setLotNumber(data?.name);
              setLotAddress(data?.address);
            }}
          />
          <SubmitButton
            title={"Delete"}
            btnClass={styles.actionBtn}
            onClick={() => {
              dispatch(
                PagesMiddleware.lotnumber({
                  payload: { id: data?.id },
                  method: "post",
                  route: "/delete",
                }),
              ).then(() => {
                setModuleSuccessModal(true);
                getData();
              });
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className={styles.upperCont}>
      <div className={styles.mainCont}>
        <div className={styles.header}>
          <div className={styles.headerinner}>
            <TextComponent text={`Lot Name`} className={styles.headerHeading} />
          </div>

          <div className={styles.rightHeader}>
            <div className={styles.searchInput}>
              <SearchInput onChange={(e) => onSearch(e)} />
            </div>
            <SubmitButton
              btnClass={styles.addbtn}
              leftIcon={<FaCirclePlus style={{ marginRight: "5px" }} />}
              title={"Add"}
              onClick={() => {
                setAddModule(true);
                setIsEdit(false);
              }}
            />
          </div>
        </div>
        <div className={styles.tableDiv}>
          <Table
            //   title={}
            scroll={{ x: true }}
            bordered={false}
            pagination={false}
            // pagination={{
            //   showSizeChanger: false,
            //   showQuickJumper: false,
            //   current: lot_numbers?.meta?.current_page,
            //   pageSize: lot_numbers?.meta?.per_page,
            //   total: lot_numbers?.meta?.total,
            //   itemRender: (_, type, originalElement) => {
            //     if (type === "prev") {
            //       return (
            //         <span
            //           style={{
            //             color: lot_numbers?.links?.prev ? "inherit" : "#ccc",
            //             cursor: lot_numbers?.links?.prev
            //               ? "pointer"
            //               : "not-allowed",
            //           }}
            //           onClick={() => {
            //             dispatch(
            //               PagesMiddleware.lotnumber({
            //                 name: search,
            //                 url: lot_numbers?.links?.prev,
            //                 method: "get",
            //               }),
            //             );
            //           }}
            //         >
            //           <LeftOutlined /> Prev
            //         </span>
            //       );
            //     }
            //     if (type === "next") {
            //       return (
            //         <span
            //           style={{
            //             color: lot_numbers?.links?.next ? "inherit" : "#ccc",
            //             cursor: lot_numbers?.links?.next
            //               ? "pointer"
            //               : "not-allowed",
            //           }}
            //           onClick={() => {
            //             dispatch(
            //               PagesMiddleware.lotnumber({
            //                 name: search,
            //                 url: lot_numbers?.links?.next,
            //                 method: "get",
            //               }),
            //             );
            //           }}
            //         >
            //           Next <RightOutlined />
            //         </span>
            //       );
            //     }
            //     return originalElement;
            //   },
            // }}
            // }}
            columns={columns}
            dataSource={lot_numbers}
          />
        </div>
      </div>

      {/* /////////////////////////Delete Module Modal///////////////////////// */}

      <Modal
        open={removeModuleModal}
        onCancel={() => setRemoveModuleModal(false)}
        icon={
          <img
            src={questionIcon}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Are you sure"}
        width={"400px"}
        twoButton
        okBtnTitle={"Yes, Remove"}
        cancelBtnTitle={"No, go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setRemoveModuleModal(false);
        }}
        onClickOkButton={() => {
          dispatch(AssetsMiddleware.deleteModule({ id: details?.id })).then(
            () => {
              setRemoveModuleModal(false);
              setModuleSuccessModal(true);
              setOpen(false);
              setDetails([]);
            },
          );
        }}
        btnStyle={{ width: "80%" }}
      >
        <TextComponent
          text={"You want to remove this device?"}
          style={{ fontFamily: "Urbanist-semibold", marginBottom: "10px" }}
        />
      </Modal>

      {/* /////////////////////////Delete Device Successfull///////////////////////// */}

      <Modal
        open={moduleSuccessModal}
        onCancel={() => setModuleSuccessModal(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"Lot Number removed"}
        width={"400px"}
        buttonTitle={"Go back"}
        onBtnPress={() => {
          setModuleSuccessModal(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>

      <Modal
        open={addModule}
        onCancel={() => setAddModule(false)}
        title={isedit ? "Update Lot Name" : "Add Lot Name"}
        width={"800px"}
        twoButton
        okBtnTitle={isedit ? "Update" : "Add"}
        cancelBtnTitle={"Go back"}
        btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setAddModule(false);
        }}
        onClickOkButton={onAddLotnumber}
        btnStyle={{ width: "80%" }}
      >
        <div className={styles.modalCont}>
          <InputField
            label={"Lot Name"}
            placeholder={"Write here"}
            value={lotNumber}
            onChange={(e) => setLotNumber(e.target.value)}
          />
          <InputField
            label={"Lot Address"}
            placeholder={"Write here"}
            value={lotAddress}
            onChange={(e) => setLotAddress(e.target.value)}
          />
        </div>
      </Modal>
    </div>
  );
};

export default LotNumber;
